<template>
  <DetailLayout fallback-path="/doubleNoList">
    <div class="detail-page">
      <div v-if="loading" class="loading">
        <i class="fas fa-spinner"></i> 正在加载批文详情...
      </div>
      
      <div v-else class="main-content">
        <div class="detail-container"> 
          <div class="detail-header"></div>
          <div v-html="htmlContent"></div>
        </div> 
      </div>
    </div>
  </DetailLayout>
</template>

<script setup>
import config from '../config.js'
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
import DetailLayout from './DetailLayout.vue'

const route = useRoute()
const id = route.params.id

const detail = ref({})
const htmlContent = ref('');
const loading = ref(true)

const fetchDetail = async () => {
  try {
    loading.value = true
    const response = await axios.get(`${config.API_BASE_URL}/api/doubleNo/selectById?id=${id}`);
    console.log(response.data.data.doubleNoUrl);
    detail.value = response.data.data;
    
    const responseHtml = await fetch('/doubleNo/'+response.data.data.doubleNoUrl);
    const html = await responseHtml.text();
    htmlContent.value = html;
  } catch (error) {
    console.error('获取批文详情失败:', error)
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchDetail()
})
</script>

<style scoped>
.detail-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.main-content {
  display: flex;
  gap: 30px;
}

.detail-container {
  flex: 3;
  background: white;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  padding: 30px;
  margin-bottom: 30px;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.loading {
  text-align: center;
  padding: 50px 0;
  color: #0083c9;
  font-size: 18px;
}

.loading i {
  animation: spin 1s linear infinite;
  margin-right: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 900px) {
  .main-content {
    flex-direction: column;
  }
  
  .detail-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
}
</style>
